// index.js or main file
import React, {useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Route, Routes, useLocation, Navigate, useParams } from 'react-router-dom';
import Login from './pages/login/login.jsx';
import AdminRedirect from './adminRedirect/admin';
import Admin from './admin/admin';
import Home from './admin/pages/home/home';
import Rules from './admin/pages/rules/rules';
import { Provider } from 'react-redux';
import { store } from './admin/store';
import LoginPage from './admin/pages/login/login';
import UserRules from './pages/rules/rules.jsx';
import ThankYou from './pages/thankyou/thankyou';
import DayFeedback from './pages/thankyou/DayFeedback';
import StreakPage from './pages/streak/StreakPage';
import Leaderboard from './pages/leaderboard/Leaderboard';
import USER from './pages/dddUI/user';
import ThemeUpdate from './admin/pages/themeupdate/themeupdate';
import Wordle from './pages/wordle/wordle';
import TeamAnthem from './pages/team-anthem/team-anthem';
import CategoryRush from './pages/category-rush/category-rush';
import SuperSquad from './pages/super-squad/super-squad';
import WildTales from './pages/wild-tales/wild-tales';
import LetterLoot from './pages/letter-loot/letter-loot';
import WordChain from './pages/word-chain/word-chain';
import NativePlaces from './pages/native-places/native-places';
import SuperPowerSquad from './pages/super-power-squad/super-power-squad';
import ComicStripChaos from './pages/comic-strip-chaos/comic-strip-chaos';
import BigPicture from './pages/big-picture/big-picture';
import Puzzle from './pages/puzzle/puzzle';
import { getStagePath } from './utils/stageRoutes';


function LegacyStageRedirect() {
  const { stageNum } = useParams();
  const path = getStagePath(stageNum);
  return <Navigate to={path || '/rules'} replace />;
}


function usePageBackground() {
  const location = useLocation();
  useEffect(() => {
    const body = document.body;
    if (!location.pathname.startsWith("/admin")) {
      body.classList.add("common-bg");
    } else {
      body.classList.remove("common-bg");
    }
  }, [location]); 
}


function App() {
  usePageBackground();

   return (
    <Provider store={store}>
      <Routes>
        {/* Admin routes (no DDDUI wrapper) */}
        <Route path="/admin">
          <Route index element={<Admin><Home /></Admin>} />
          <Route path="rules" element={<Admin><Rules /></Admin>} />
          <Route path="themeupdate" element={<Admin><ThemeUpdate /></Admin>} />
          <Route path="superadmin" element={<LoginPage/>} />
        </Route>

        {/* Public routes wrapped with DDDUI */}
        <Route path="*" element={
          <USER>
            <Routes>
              <Route index element={<Login />} />
              <Route path="/login" element={<Login />} />
              <Route path="/rules" element={<UserRules/>} />
              <Route path="/leaderboard" element={<Leaderboard/>} />
              <Route path="/AdminRedirect" element={<AdminRedirect />} />
              <Route path="/thankyou" element={<ThankYou/>} />
              <Route path="/feedback" element={<DayFeedback/>} />
              <Route path="/streak" element={<StreakPage/>} />
              <Route path="/wordle" element={<Wordle />} />
              <Route path="/team-anthem" element={<TeamAnthem />} />
              <Route path="/category-rush" element={<CategoryRush />} />
              <Route path="/super-squad" element={<SuperSquad />} />
              <Route path="/wild-tales" element={<WildTales />} />
              <Route path="/letter-loot" element={<LetterLoot />} />
              <Route path="/word-chain" element={<WordChain />} />
              <Route path="/native-places" element={<NativePlaces />} />
              <Route path="/super-power-squad" element={<SuperPowerSquad />} />
              <Route path="/comic-strip-chaos" element={<ComicStripChaos />} />
              <Route path="/stage:stageNum" element={<LegacyStageRedirect />} />
              <Route path="/Stage:stageNum" element={<LegacyStageRedirect />} />
              <Route path="/big-picture" element={<BigPicture />} />
              <Route path="/puzzle" element={<Puzzle />} />
            </Routes>
          </USER>
        } />
      </Routes>
    </Provider>
  );
}

// Benign browser warning when ResizeObserver callbacks affect layout (e.g. jigsaw resize).
window.addEventListener('error', (event) => {
  const message = String(event?.message ?? '');
  if (
    message.includes('ResizeObserver loop completed with undelivered notifications') ||
    message.includes('ResizeObserver loop limit exceeded')
  ) {
    event.stopImmediatePropagation();
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

// Performance reporting
reportWebVitals();
